module.exports = __webpack_public_path__ + "img/kingsize-bed.1ed2e21c.svg";